module.exports = __webpack_public_path__ + "static/stouffville-f0b8714daba73d4ed718d8f6be9d76c2.jpg";